<div>
  <mat-drawer-container>
    <button class="sitcky-btn-comment" mat-raised-button color="primary" (click)="close(ctsedit)"><mat-icon>message</mat-icon></button>
    <button class="sitcky-btn-comment add" mat-raised-button color="primary" (click)="openEditComment(comment, ctsedit)"><mat-icon>create</mat-icon></button>
    <mat-drawer [ngStyle]="{'width': '100%'}" #ctsedit position="end" mode="over">
      <app-comment-edit [ngStyle]="{'width': '100%', 'display':'block'}" [commentator]="commentator" [isGestionnaire]="isGestionnaire()" [dossier]="dossier" [comment]="comment" (closeCts)="editClose($event, ctsedit)"></app-comment-edit>
    </mat-drawer>
    <mat-button-toggle-group  #comments_filter name="filtres" aria-label="filtres">
        <mat-button-toggle *ngIf="isGestionnaire()" [checked]="isGestionnaire()" (click)="clickAll()">Tous</mat-button-toggle>
        <mat-button-toggle [checked]="!isGestionnaire()" (click)="clickPublic()">Publics</mat-button-toggle>
        <mat-button-toggle *ngIf="isGestionnaire()" (click)="clickPrivate()">Privés</mat-button-toggle>
    </mat-button-toggle-group>
    <app-comment *ngFor="let comment of comments"
                 [comment]="comment"
                 [individu]="commentator"
                 (editComment)="openEditComment($event, ctsedit)"
                 (delComment)="deleteComment($event)"
    ></app-comment>
  </mat-drawer-container>
</div>
